export const CASH_EVIDENCE_MAX_FILE_MB = 20
const MAX_EVIDENCE_LENGTH = 600000

// Invoke this from the click handler, before a network request or Vue render.
export async function captureCashEvidence(input) {
  const bridge = window.flutter_inappwebview
  if (!bridge || typeof bridge.callHandler !== "function") {
    if (input) input.click()
    return null
  }
  const result = await bridge.callHandler("openCameraNative")
  if (!result || !result.success) {
    if (result && result.error) throw new Error("Die Kamera konnte nicht geöffnet werden. Bitte erneut versuchen oder ein Bild auswählen.")
    return null
  }
  const encoded = typeof result.base64 === "string" ? result.base64.replace(/^data:image\/(?:jpeg|png);base64,/, "") : ""
  if (!encoded || encoded.length > Math.ceil(CASH_EVIDENCE_MAX_FILE_MB * 1024 * 1024 / 3) * 4 || !/^[A-Za-z\d+/]+={0,2}$/.test(encoded)) throw new Error("Das Kamerafoto konnte nicht gelesen werden. Bitte erneut fotografieren.")
  const bytes = Uint8Array.from(window.atob(encoded), value => value.charCodeAt(0))
  const type = bytes[0] === 255 && bytes[1] === 216 && bytes[2] === 255 ? "image/jpeg"
    : [137, 80, 78, 71, 13, 10, 26, 10].every((value, index) => bytes[index] === value) ? "image/png" : ""
  if (!type) throw new Error("Bitte ein JPEG- oder PNG-Belegfoto aufnehmen.")
  return new File([bytes], result.name || (type === "image/png" ? "beleg.png" : "beleg.jpg"), { type })
}

export function cashEvidence(file) {
  return new Promise((resolve, reject) => {
    if (!file || !["image/jpeg", "image/png"].includes(file.type) || !file.size || file.size > CASH_EVIDENCE_MAX_FILE_MB * 1024 * 1024) return reject(new Error(`Bitte ein JPEG- oder PNG-Belegfoto bis ${CASH_EVIDENCE_MAX_FILE_MB} MB waehlen.`))
    const url = URL.createObjectURL(file), image = new Image()
    const done = () => URL.revokeObjectURL(url)
    image.onerror = () => { done(); reject(new Error("Das Belegfoto konnte nicht gelesen werden.")) }
    image.onload = () => {
      try {
        if (!image.width || !image.height) throw new Error("Das Belegfoto konnte nicht gelesen werden.")
        const canvas = document.createElement("canvas"), context = canvas.getContext("2d")
        if (!context) throw new Error("Das Belegfoto konnte nicht verarbeitet werden. Bitte erneut versuchen.")
        // Keep the private stored evidence within the existing server limit.
        // Preserve resolution first, then reduce dimensions only when necessary.
        for (const maxEdge of [1800, 1440, 1152]) {
          const scale = Math.min(1, maxEdge / Math.max(image.width, image.height))
          canvas.width = Math.max(1, Math.round(image.width * scale)); canvas.height = Math.max(1, Math.round(image.height * scale))
          context.fillStyle = "#fff"; context.fillRect(0, 0, canvas.width, canvas.height); context.drawImage(image, 0, 0, canvas.width, canvas.height)
          for (const quality of [.8, .7, .6]) {
            const data = canvas.toDataURL("image/jpeg", quality)
            if (!data.startsWith("data:image/jpeg;base64,")) throw new Error("Das Belegfoto konnte nicht verarbeitet werden. Bitte erneut versuchen.")
            if (data.length <= MAX_EVIDENCE_LENGTH) { resolve(data); return }
          }
        }
        throw new Error("Das Belegfoto konnte nicht ausreichend verkleinert werden. Bitte nur den Beleg fotografieren.")
      } catch (error) { reject(error) } finally { done() }
    }
    image.src = url
  })
}
